import AdminContentLayout from "../../../../layouts/AdminContentLayout";
import ProgressBarLoadingIndicator from "./ProgressBarLoadingIndicator";
import SelectTestLoadingIndicator from "./SelectTestLoadingIndicator";
import SideNavLoadingIndicator from "./SideNavLoadingIndicator";

function OrderLoadingIndicator(): JSX.Element {
  return (
    <AdminContentLayout
      pageTitle="Update Order | CSTL"
      subHeaderTitle="Update Order"
    >
      <div className="grid gird-cols-twoColumnSettingsTabletPageLayout lg:grid-cols-twoColumnSettingsPageLayout overflow-hidden h-[calc(100vh_-_120px)]">
        <SideNavLoadingIndicator />
        <div className="w-full overflow-y-auto">
          <ProgressBarLoadingIndicator />
          <SelectTestLoadingIndicator padding="px-6 lg:px-[109px]" />
        </div>
      </div>
    </AdminContentLayout>
  );
}

export default OrderLoadingIndicator;
